import { noop } from 'lodash'

import { Noop } from '../types/utilities'

export const promisify = <T extends Noop>(fn: T) => {
  return (...args: any[]) =>
    new Promise((resolve, reject) => {
      try {
        resolve(fn(...args))
      } catch (e) {
        reject(e)
      }
    })
}

export const promiseNoop = promisify(noop) as Noop<Promise<any>>
